import { render, staticRenderFns } from "./GroupHistorical.vue?vue&type=template&id=6ae7faaa&scoped=true&"
import script from "./GroupHistorical.vue?vue&type=script&lang=js&"
export * from "./GroupHistorical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae7faaa",
  null
  
)

export default component.exports